/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import e from"../../widgets/support/Selector2D/SelectionOperation.js";function o(o,t,r){return new e({view:o,sources:t,options:r})}export{o as createSelectionOperation};
